import React from 'react'
import Footer from '../../Footer'
import bg from '../../../img/id/fourier/bg.png'
import logo from '../../../img/id/fourier/logo.png'
import fig1 from '../../../img/id/fourier/1.png'


import '../Proj.css'

export default class ProjFourier extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div id='fourier-title'>
                    <img src={logo} />
                    <h1>Hanging Lamp Design</h1>
                    <p>Under supervision of Prof. Ming-Huang Lin.</p>
                </div>
                <div className='proj-bg'>
                    <img src={bg} />
                </div>
                <div className='proj-fig1'>
                    <img src={fig1} />
                </div>
                <p className='little-title'>Modeling with Rhino7.0, prototyping with paper and metal wires.</p>
                <div className='proj-content'>
                    <p>I want to make a lamp that is composed of simple material yet with an intriguing look. The wave-like pattern comes from the imagery of two convoluted sine waves with different frequencies and magnitudes. In the frequency domain, they are separated into two independent frequencies, while in the time domain, it is a beautiful waveform. This is the design project I did one year after beginning to minor in industrial design. Engineering and designing may be seen as two separate domains from one perspective. Still, in another perspective, which I believe in my future, these two domains and the skills I learned will be blended together beautifully.
                    </p>
                </div>
                <Footer back={true}/>
            </div>
        )
    }
}